import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetActivityTypeDefaults as GetActivityTypeDefaultsQuery,
    GetActivityTypeDefaults_activityTypeDefaults as ActivityTypeDefault,
} from 'nutshell-graphql-types';

import GET_ACTIVITY_TYPE_DEFAULTS from '../queries/get-activity-type-defaults.graphql';

export function useGetActivityTypeDefaults(): {
    activityTypeDefaults: ActivityTypeDefault[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, error, loading, refetch} = useQuery<
        GetActivityTypeDefaultsQuery,
        Record<any, any>
    >(GET_ACTIVITY_TYPE_DEFAULTS, {
        fetchPolicy: 'cache-and-network',
    });

    return {
        activityTypeDefaults: data && data.activityTypeDefaults ? data.activityTypeDefaults : [],
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
